module.exports = __webpack_public_path__ + "img/habitation-bbc.711a2f82.svg";